// Fenêtre de confirmation d'une régénération d'ERA sur un exercice verrouillé (option C du
// conseil, 03/11/2026) : exercice prêt pour la signature, en attente de signature, signé,
// envoyé ou facturé. Le serveur refuse (409 DOSSIER_VERROUILLE) tant qu'aucun motif n'est donné ;
// avec un motif, il régénère et repasse l'exercice à « cerfa_genere ».
import React, { useEffect, useState } from "react";
import { FiX, FiAlertTriangle } from "react-icons/fi";

export const MOTIF_MIN = 10; // aligné sur backend/src/utils/verrouSignatureEra.js

export default function RegenerationVerrouilleeModal({ open, pdl, message, onClose, onConfirm }) {
  const [motif, setMotif] = useState("");
  useEffect(() => { if (open) setMotif(""); }, [open, pdl?.id]);
  if (!open || !pdl) return null;
  const valide = motif.trim().length >= MOTIF_MIN;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 px-4" data-testid="modal-regeneration-verrouillee">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        <div className="flex items-start justify-between px-4 py-3 border-b">
          <div>
            <h2 className="text-xs font-semibold text-gray-800 flex items-center"><FiAlertTriangle className="h-4 w-4 mr-1.5 text-amber-600" />Régénérer un ERA déjà préparé pour la signature</h2>
            <p className="text-[10px] text-gray-500 mt-0.5">PDL <span className="font-mono">{pdl.pdl_number}</span> — {pdl.site_name || "—"}</p>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-700 -mt-1" aria-label="Fermer"><FiX className="h-5 w-5" /></button>
        </div>
        <div className="px-4 py-4 space-y-3">
          <p className="text-xs text-gray-700 leading-snug">{message}</p>
          <div>
            <label htmlFor="motif-regeneration" className="block text-xs font-medium text-gray-700 mb-1">Motif de la régénération</label>
            <textarea id="motif-regeneration" rows={3} value={motif} onChange={(e) => setMotif(e.target.value)}
              placeholder="ex. séparation de la majoration ZNI (3310 lignes K/N)"
              className="w-full px-2 py-1 border border-gray-300 rounded text-xs focus:outline-none focus:ring-1 focus:ring-blue-500" />
            {!valide && motif !== "" && <p className="text-[10px] text-red-600 mt-1">{MOTIF_MIN} caractères au moins.</p>}
          </div>
          <p className="text-[10px] text-gray-500 leading-snug">L'exercice repassera à l'étape « CERFA généré ». Les nouveaux ERA devront être de nouveau signés ; une demande Yousign en cours est à annuler à la main.</p>
        </div>
        <div className="flex items-center justify-end gap-2 px-4 py-3 border-t bg-slate-50 rounded-b-lg">
          <button onClick={onClose} className="px-2 py-1 text-xs text-gray-600 hover:text-gray-900">Annuler</button>
          <button onClick={() => valide && onConfirm(motif.trim())} disabled={!valide} data-testid="regeneration-confirmer"
            className={`px-2 py-1 text-xs font-medium rounded text-white ${valide ? "bg-amber-600 hover:bg-amber-700" : "bg-gray-300 cursor-not-allowed"}`}>
            Régénérer quand même
          </button>
        </div>
      </div>
    </div>
  );
}
